import React, { FC } from 'react'
// import { useNavigate } from 'react-router-dom'
import {
  Module,
  ModuleHeader,
  ModuleBody,
  CustomAlert,
  // CustomButton,
  // ButtonContainer,
} from 'components'
interface IProps {
  serviceError: string
}

const ChangePasswordConfirmation: FC<IProps> = ({ serviceError }) => {
  // const history = useNavigate()

  return (
    <Module>
      <ModuleHeader title="You're all set!">
        <CustomAlert severity="success" title="Success!">
          Your password has been changed successfully.
        </CustomAlert>
        <CustomAlert severity="error">{serviceError}</CustomAlert>
      </ModuleHeader>

      <ModuleBody children={undefined}>
        {/* <ButtonContainer
          primary={
            <CustomButton onClick={() => history.goBack()}>Return</CustomButton>
          }
          secondary={<div />}
        /> */}
      </ModuleBody>
    </Module>
  )
}

export default ChangePasswordConfirmation
